import CompanyService from '@/domain/services/company';
import RegionalService from '@/domain/services/regional';
import InstallationService from '@/domain/services/installation';
import AssetService from '@/domain/services/asset';
import ModuleService from '@/domain/services/module';

export default {
  methods: {
    async getCompanies() {
      return CompanyService.getCompanies();
    },
    async getRegional(companyIds = []) {
      if (!companyIds.length) {
        return [];
      }

      return RegionalService.getRegional(companyIds);
    },
    async getInstallation(companyIds = [], regionalIds = []) {
      if (!companyIds.length) {
        return [];
      }

      const params = {
        companiesIds: companyIds,
        regionalIds,
      };

      return InstallationService.getInstallationsByCompaniesOrRegional(params);
    },
    async getAssets(installationIds = []) {
      if (!installationIds.length) {
        return [];
      }

      const params = {
        installationsIds: installationIds,
      };
      const response = await AssetService.getAssetsByInstallations(params);
      return (response || []).map(item => ({
        id: item.id,
        name: `${item.installation?.name} | ${item.name}`,
        installation: item.installation,
      }));
    },
    async getSensors(assetsIds = []) {
      if (!assetsIds.length) {
        return [];
      }

      const params = {
        assetsIds,
      };

      return ModuleService.getSensorsByAssetIds(params);
    },
    getItemsIfIsNotAllSelected(selectedList, completeList) {
      if (!selectedList?.length) {
        return [];
      }
      const selectedListIds = selectedList.map(({ id }) => (id || '').toUpperCase());
      const completeListIds = (completeList || []).map(({ id }) => (id || '').toUpperCase());

      if (completeListIds.length > 0
        && completeListIds.every(item => selectedListIds.includes(item))) {
        return [];
      }

      return selectedList.map(({ name }) => ({ name }));
    },
    filterByListWithNormalizedIds(list, filterIds) {
      if (filterIds?.length) {
        const upperIds = filterIds.map(x => (x.id || '').toUpperCase());
        return list.filter(x => upperIds.includes((x.id || '').toUpperCase()));
      }

      return list;
    },
  },
};
